<ion-header>
  <ion-toolbar>
    <ion-title class="tw-uppercase tw-text-center">place wager</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="abc-modal-container">

  <div class="
    race-pool tw-mt-[19px] tw-border-b tw-border-[#2F80EC] tw-pb-[5px]
  ">
    <span class="tw-block tw-uppercase tw-font-bold tw-text-[19px] tw-text-[#000000]">
      {{eventName}}
    </span>
    <span class="
      tw-uppercase tw-font-bold tw-text-[19px] tw-text-[#000000]
    ">
      race {{selectedRace?.RaceId}}
    </span>
  </div>

  <div class="current-bets tw-relative">
    <div
      *ngFor="let parentItem of abcTicket; index as i"
      class="clear-both"
    >
      <div
        *ngIf="parentItem.ABCTicket !== null && parentItem.ABCTicket.Wagers.length > 0"
        class="abc-type tw-border-b tw-border-[#6C6C6C]"
      >
        <div *ngIf="i === 0" class="tw-pt-[13px]">
          <span class="tw-font-bold tw-text-[12px] tw-text-[#2F80EC]">All As</span>
        </div>

        <div *ngIf="i === 1" class="tw-pt-[13px]">
          <span class="tw-font-bold tw-text-[12px] tw-text-[#2F80EC]">All As and Bs</span>
        </div>

        <div *ngIf="i === 2" class="tw-pt-[13px]">
          <span class="tw-font-bold tw-text-[12px] tw-text-[#2F80EC]">As with One B</span>
        </div>

        <div *ngIf="i === 3" class="tw-pt-[13px]">
          <span class="tw-font-bold tw-text-[12px] tw-text-[#2F80EC]">As and Two Bs</span>
        </div>

        <div *ngIf="i === 4" class="tw-pt-[13px]">
          <span class="tw-font-bold tw-text-[12px] tw-text-[#2F80EC]">As with One C</span>
        </div>
      </div>

      <div
        *ngFor="let childItem of parentItem.ABCTicket.Wagers; index as z"
        class="tw-border-b tw-border-[#B4B3B3] tw-py-[2px]"
      >

        <div class="clear-both tw-border-b tw-border-[#B4B3B3]">
          <div class="amount1 tw-float-left">
            <span class="tw-font-bold tw-text-[12px] tw-text-[#000000]">
              ${{childItem.BaseAmount}}
            </span>
          </div>
          <div class="amount-percent tw-float-left">
            <span class="tw-font-bold tw-text-[12px] tw-text-[#000000]">
              {{childItem.getWagerString()[2]}}
            </span>
          </div>
        </div>

        <div class="no-valid-wager">
          <span id="error-index-{{ i }}" class="tw-text-[13px] tw-text-[#FF0000]">
            {{childItem.Error}}
          </span>
        </div>

        <div class="clear-both">
          <span
            class="amount2 tw-float-left tw-block tw-font-bold tw-text-[12px] tw-text-[#000000]"
          >
            ${{
              (
                childItem.BaseAmount * childItem.Bets
              ).toFixed(2)
            }}
          </span>

          <div class="tw-float-right">
            <span
              *ngIf="!parentItem?.submitted && !parentItem?.saved && !parentItem?.removed"
              (click)="submitBet(i)"
              class="
                submit-bet tw-uppercase tw-font-bold tw-text-[14px] tw-text-[#2F80EC] tw-mr-[15px]
              "
            >
              submit
            </span>
            <span
              *ngIf="!parentItem?.submitted && !parentItem?.saved && !parentItem?.removed"
              (click)="saveBet(i)"
              class="
                save-bet tw-uppercase tw-font-bold tw-text-[14px] tw-text-[#2F80EC] tw-mr-[20px]
              "
            >
              save
            </span>
            <img
            *ngIf="!parentItem?.submitted && !parentItem?.saved && !parentItem?.removed"
              (click)="removeBet(i)"
              src="/assets/images/account_settings/trash_icon_light.svg"
              class="l-mode tw-z-50 tw-relative tw-top-[4px] tw-float-right"
              alt="trash icon"
            >
            <img
              *ngIf="!parentItem?.submitted && !parentItem?.saved && !parentItem?.removed"
              (click)="removeBet(i)"
              src="/assets/images/account_settings/trash_icon_dark.svg"
              class="d-mode tw-z-50 tw-relative tw-top-[4px] tw-float-right"
              alt="trash icon"
            >

            <span
              *ngIf="parentItem?.submitted"
              class="tw-uppercase tw-font-bold tw-text-[14px] tw-text-[#2F80EC] tw-mr-[20px]"
            >
              submitted
            </span>

            <span
              *ngIf="parentItem?.saved"
              class="tw-uppercase tw-font-bold tw-text-[14px] tw-text-[#2F80EC] tw-mr-[20px]"
            >
              submitted
            </span>

            <span
              *ngIf="parentItem?.removed"
              class="tw-uppercase tw-font-bold tw-text-[14px] tw-text-[#2F80EC] tw-mr-[20px]"
            >
              removed
            </span>
          </div>
        </div>

      </div>
    </div>
  </div>

  <ion-grid class="submit-save-close-btns tw-mt-[50px] tw-pr-[0] tw-pl-[0]">
    <ion-row>
      <ion-col class="tw-pl-[0] tw-pr-[0] sm">
        <ion-button (click)="submitAll()" class="confirm-btn">
          submit all
        </ion-button>
      </ion-col>
      <ion-col class="tw-text-center sm">
        <ion-button (click)="saveAll()" class="confirm-btn">
          save all
        </ion-button>
      </ion-col>
      <ion-col class="tw-text-right tw-pl-[0] tw-pr-[0] sm">
        <ion-button (click)="close()" class="cancel-all-btn">
          close all
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>
